/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Změnit zemi`
};

const da_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Skift land`
};

const de_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Land wechseln`
};

const en_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Change country`
};

const es_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Cambiar país`
};

const fr_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Changer de pays`
};

const hu_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Ország módosítása`
};

const it_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Cambia paese`
};

const nl_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Land wijzigen`
};

const pl_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Zmień kraj`
};

const pt_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Alterar país`
};

const sv_change_country = /** @type {(inputs: {}) => string} */ () => {
	return `Byt land`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const change_country = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.change_country(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("change_country", locale)
	if (locale === "cs") return cs_change_country(inputs)
	if (locale === "da") return da_change_country(inputs)
	if (locale === "de") return de_change_country(inputs)
	if (locale === "en") return en_change_country(inputs)
	if (locale === "es") return es_change_country(inputs)
	if (locale === "fr") return fr_change_country(inputs)
	if (locale === "hu") return hu_change_country(inputs)
	if (locale === "it") return it_change_country(inputs)
	if (locale === "nl") return nl_change_country(inputs)
	if (locale === "pl") return pl_change_country(inputs)
	if (locale === "pt") return pt_change_country(inputs)
	return sv_change_country(inputs)
};